import React from 'react';

export default function Disclosure() {
  return (
    <section
      data-testid="legal-disclosure"
      className="w-full border-t border-neutral-900/10 bg-[color:var(--alfa-sand)]"
    >
      <div className="w-full px-4 sm:px-8 lg:px-16 py-14 sm:py-16 md:py-20">
        {/* Intro */}
        <div className="space-y-4 text-[14px] sm:text-[14.5px] leading-[1.75] text-neutral-950 max-w-none">
          <p className="font-semibold text-[color:var(--alfa-navy)] text-[15.5px] sm:text-[16px]">
            Physician-led GLP-1 weight loss programs. Cash-pay, no insurance, no waiting rooms.
          </p>
          <p>
            By subscribing you agree to with our Privacy Policy and provide consent to receive updates from our company.
          </p>
          <p>
            By submitting this form, you agree to our Privacy Policy and consent to receive marketing communications
            (including updates, promotions, and information about our services) from Arora Health &amp; Aesthetics via
            email, SMS, and/or phone. You understand that message frequency will vary and that message and data rates
            may apply. Your consent to receive marketing messages is not a condition of purchasing any goods or
            services. You may unsubscribe at any time by clicking the unsubscribe link in our emails or by replying
            &ldquo;STOP&rdquo; to any of our text messages.
          </p>
        </div>

        {/* 3-column address / provider / pharmacy */}
        <div className="mt-10 sm:mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 border-t border-neutral-900/10 pt-10">
          <div>
            <h3 className="font-display uppercase tracking-[0.08em] text-[15px] text-[color:var(--alfa-navy)]">
              Arora Health &amp; Aesthetics
            </h3>
            <p className="mt-3 text-[14px] sm:text-[14.5px] leading-[1.75] text-neutral-950">
              300 Lenora Street<br />
              Seattle, WA 98121<br />
              <span className="whitespace-nowrap">(630) 480-6162</span>
            </p>
          </div>

          <div>
            <h3 className="font-display uppercase tracking-[0.08em] text-[15px] text-[color:var(--alfa-navy)]">
              Clinical Provider Information
            </h3>
            <p className="mt-3 text-[14px] sm:text-[14.5px] leading-[1.75] text-neutral-950">
              Arora Health &amp; Aesthetics, LLC provides clinical care for this program through licensed providers,
              subject to applicable state licensure requirements and telehealth regulations.
            </p>
            <p className="mt-3 text-[14px] sm:text-[14.5px] leading-[1.75] text-neutral-950">
              <span className="font-semibold">Address:</span> 300 Lenora Street, Seattle, WA 98121<br />
              <span className="font-semibold">Email:</span>{' '}
              <a
                href="mailto:medicalcompliance@arorahealthgroup.com"
                className="text-[color:var(--alfa-royal)] underline underline-offset-2"
              >
                medicalcompliance@arorahealthgroup.com
              </a>
              <br />
              <span className="font-semibold">Website:</span>{' '}
              <a
                href="https://www.arora-health.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[color:var(--alfa-royal)] underline underline-offset-2"
              >
                www.arora-health.com
              </a>
            </p>
          </div>

          <div>
            <h3 className="font-display uppercase tracking-[0.08em] text-[15px] text-[color:var(--alfa-navy)]">
              Partner Pharmacy Information
            </h3>
            <p className="mt-3 text-[14px] sm:text-[14.5px] leading-[1.75] text-neutral-950" data-testid="partner-pharmacy-info">
              VialsRX<br />
              6220 Westpark Dr<br />
              Houston, TX 77057<br />
              Phone:{' '}
              <a href="tel:+17134975590" className="underline underline-offset-2">(713) 497-5590</a><br />
              Website:{' '}
              <a
                href="https://vials.ai"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="partner-pharmacy-link"
                className="text-[color:var(--alfa-royal)] underline underline-offset-2"
              >
                vials.ai
              </a>
            </p>
            <p className="mt-3 text-[13.5px] leading-[1.7] text-neutral-950 italic">
              Services are available in all 50 US states through affiliated medical providers and pharmacy partners
              operating in accordance with applicable state licensure requirements.
            </p>
            <p className="mt-3 text-[13.5px] leading-[1.7] text-neutral-950 italic">
              Please note that certain medications, formulations, or fulfillment options may vary depending on
              state-specific pharmacy regulations and dispensing restrictions.
            </p>
          </div>
        </div>

        {/* Legal disclaimer */}
        <div className="mt-12 border-t border-neutral-900/10 pt-10 space-y-5 text-[13.5px] sm:text-[14px] leading-[1.75] text-neutral-950">
          <h3 className="font-display uppercase tracking-[0.08em] text-[16px] sm:text-[18px] text-[color:var(--alfa-navy)]">
            Legal Disclaimer &amp; Important Disclosures
          </h3>
          <p>
            The information and services described on this website are intended for licensed medical professionals and
            healthcare practices. The content provided is for informational purposes only and does not constitute
            medical, legal, or regulatory advice.
          </p>

          <div>
            <h4 className="font-semibold text-[color:var(--alfa-navy)] text-[14.5px] uppercase tracking-[0.06em]">
              Not Medical Advice
            </h4>
            <p className="mt-2">
              This website does not offer medical advice. The information provided, including but not limited to text,
              graphics, images, and other material, is not intended to be a substitute for professional medical advice,
              diagnosis, or treatment. Practices should rely on the professional judgment of their licensed medical
              providers for any medical decisions.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-[color:var(--alfa-navy)] text-[14.5px] uppercase tracking-[0.06em]">
              FDA &amp; Service Disclosures
            </h4>
            <p className="mt-2">
              The statements on this website have not been evaluated by the Food and Drug Administration (FDA). The
              services and products mentioned, including but not limited to peptide therapies, hormone therapies, and
              regenerative medicine, may not be FDA-approved for the uses discussed. Arora Health &amp; Aesthetics does
              not endorse or make any claims about the efficacy, safety, or appropriateness of any specific tests,
              products, procedures, or opinions. It is the sole responsibility of the treating provider to ensure that
              any treatment or therapy administered is compliant with all applicable laws and regulations and is
              appropriate for the specific patient.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-[color:var(--alfa-navy)] text-[14.5px] uppercase tracking-[0.06em]">
              Testimonials &amp; Results
            </h4>
            <p className="mt-2">
              Testimonials appearing on this site reflect the real-life experiences of those who have used our services.
              However, they are individual results and results do vary. We do not claim that they are typical results
              that all clients will achieve. Testimonials are not necessarily representative of all of those who will
              use our services. Where a testimonial has been compensated, this is disclosed.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
